















































































import Vue from "vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { ReportTypeEnum, ReportTypeEnumInterface } from "@/features/analytics/enums/ReportType";
import { PeriodEnum, PeriodEnumInterface } from "@/commons/enums/Period";
import {
  getToday,
  isIncludeLeapYearByStartDate,
  isDiffOfTwoDateOverTargetDays,
} from "@/commons/utils/dateHandling";

const THIRTY_ONE_DAYS_AVAILABILITY_PERIOD = 31;
const ONE_YEAR_AVAILABILITY_PERIOD = 1;
const ONE_YEAR_DAYS_AVAILABILITY_PERIOD = 365;
const ONE_LEAP_YEAR_DAYS_AVAILABILITY_PERIOD = 366;

extend("period_for_thirty_one_days", {
  params: [
    {
      name: "target",
      isTarget: true,
    },
  ],
  message: `選択期間を${THIRTY_ONE_DAYS_AVAILABILITY_PERIOD}日以内にしてください`,
  validate(value, { target }: any) {
    // レポートで選択できる期間(days)
    return !isDiffOfTwoDateOverTargetDays(value, target, THIRTY_ONE_DAYS_AVAILABILITY_PERIOD);
  },
});
extend("period_for_one_year", {
  params: [
    {
      name: "target",
      isTarget: true,
    },
  ],
  message: `選択期間を${ONE_YEAR_AVAILABILITY_PERIOD}年以内にしてください`,
  validate(value, { target }: any) {
    // レポートで選択できる期間(days)
    return !isDiffOfTwoDateOverTargetDays(value, target, ONE_YEAR_DAYS_AVAILABILITY_PERIOD);
  },
});
extend("period_for_one_leap_year", {
  params: [
    {
      name: "target",
      isTarget: true,
    },
  ],
  message: `選択期間を${ONE_YEAR_AVAILABILITY_PERIOD}年以内にしてください`,
  validate(value, { target }: any) {
    // レポートで選択できる期間(days)
    return !isDiffOfTwoDateOverTargetDays(value, target, ONE_LEAP_YEAR_DAYS_AVAILABILITY_PERIOD);
  },
});

export default Vue.extend({
  components: {
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
  },
  data() {
    return {
      today: getToday(),
      menu: false as boolean,
      menu2: false as boolean,
      periodEnum: PeriodEnum.getEnum() as PeriodEnumInterface,
      reportTypeEnum: ReportTypeEnum.getEnum() as ReportTypeEnumInterface,
    };
  },

  props: {
    reportTypeInput: { type: Number, required: true },
    periodInput: { type: Number, required: true },
    startDateInput: { type: String, required: true },
    endDateInput: { type: String, required: true },
  },

  computed: {
    childStartDateInput: {
      get(this: any) {
        return this.startDateInput;
      },
      set(val) {
        return this.$emit("update:startDateInput", val);
      },
    },
    childEndDateInput: {
      get() {
        return this.endDateInput;
      },
      set(val) {
        return this.$emit("update:endDateInput", val);
      },
    },
    periodRule(): string {
      if (this.reportTypeInput === ReportTypeEnum.PREBID_ANALYTICS.value) {
        return "period_for_thirty_one_days:start";
      }
      if (isIncludeLeapYearByStartDate(new Date(this.childStartDateInput))) {
        return "period_for_one_leap_year:start";
      }
      return "period_for_one_year:start";
    },
  },

  methods: {
    getMinStartDate(): string | undefined {
      if (this.reportTypeInput === ReportTypeEnum.PREBID_ANALYTICS.value) {
        return "2021-10-01";
      } else if (this.reportTypeInput === ReportTypeEnum.BI_REPORT.value) {
        return "2019-04-01";
      } else if (this.reportTypeInput === ReportTypeEnum.GOOGLE_AD_MANAGER.value) {
        return "2022-02-01";
      }
    },
    isIncludeLeapYear(target: string): boolean {
      return isIncludeLeapYearByStartDate(new Date(target));
    },
  },

  watch: {
    childStartDateInput: function () {
      // 「開始日」を変更し開始日が終了日を超えた場合、終了日を開始日と同じ日付に変更
      if (this.startDateInput > this.endDateInput)
        this.childEndDateInput = this.childStartDateInput;
    },
    childEndDateInput: function () {
      // 「終了日」を変更し開始日が終了日を超えた場合、開始日を終了日と同じ日付に変更
      if (this.startDateInput > this.endDateInput)
        this.childStartDateInput = this.childEndDateInput;
    },
  },
});
